import Module from '../utils/Module';

export default class FooterModule extends Module {
  constructor (options) {
    super(options);

    this.DOMEl = this.options.element;

    this.menuLinks = this.DOMEl.querySelectorAll(".menu--utility a");
    this.menuFooterLinks = this.DOMEl.querySelectorAll(".menu--footer a");
    this.socialLinks = this.DOMEl.querySelectorAll(".social-media-links--platforms a");

    this.init();
  }

  init () {
    this.menuLinks.forEach(link => {
      link.addEventListener('click', () => {
        this.trackMenuClick(link);
      });
    });

    this.menuFooterLinks.forEach(link => {
      link.addEventListener('click', () => {
        this.trackFooterMenuClick(link);
      });
    });

    this.socialLinks.forEach(socialLink => {
      socialLink.addEventListener('click', () => {
        this.trackSocialClick(socialLink);
      });
    });
  }

  trackMenuClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "footer interaction",
        "action": link.text.toLowerCase()
      }
    });
  }

  trackFooterMenuClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "footer interaction",
        "action": link.text.toLowerCase(),
        "label": link.href
      }
    });
  }

  trackSocialClick(link) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "footer interaction",
        "action": "social media",
        "label": link.text.toLowerCase()
      }
    });
  }
}
